import { createActions, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';

import * as loadingState from '@coconut/constants/loadingState';

export const types = {
  FETCH_COMPLETED_QUESTIONS: 'FETCH_COMPLETED_QUESTIONS',
  FETCH_COMPLETED_QUESTIONS_SUCCESS: 'FETCH_COMPLETED_QUESTIONS_SUCCESS',
  FETCH_COMPLETED_QUESTIONS_FAILED: 'FETCH_COMPLETED_QUESTIONS_FAILED',
  UPDATE_COMPLETED_QUESTIONS_COUNT: 'UPDATE_COMPLETED_QUESTIONS_COUNT',

  UPDATE_AASMSTATE_AFTER_RATE_SUCCESS: 'UPDATE_AASMSTATE_AFTER_RATE_SUCCESS',

  CLEAN_COMPLETED_QUESTIONS: 'CLEAN_COMPLETED_QUESTIONS',
};

export const {
  fetchCompletedQuestions,
  fetchCompletedQuestionsSuccess,
  fetchCompletedQuestionsFailed,
  updateCompletedQuestionsCount,
  updateAasmstateAfterRateSuccess,
  cleanCompletedQuestions,
} = createActions(
  {
    [types.FETCH_COMPLETED_QUESTIONS]: ({ userId, searchIds }) => ({
      userId,
      searchIds,
    }),
    [types.FETCH_COMPLETED_QUESTIONS_SUCCESS]: ({
      questions,
      currentPage,
      count,
      hasUnread,
    }) => ({
      questions,
      count,
      hasUnread,
      currentPage,
    }),
    [types.FETCH_COMPLETED_QUESTIONS_FAILED]: (errorMessage) => ({
      errorMessage,
    }),
    [types.UPDATE_COMPLETED_QUESTIONS_COUNT]: (count) => ({ count }),
    [types.UPDATE_AASMSTATE_AFTER_RATE_SUCCESS]: (updatedQuestion) => ({
      updatedQuestion,
    }),
  },
  types.CLEAN_COMPLETED_QUESTIONS
);

const INIT_STATE = {
  loadingStatus: loadingState.EMPTY,
  questions: [],
  currentPage: 0,
  count: 0,
  hasUnread: false,
  errorMessage: '',
};

const reducer = handleActions(
  {
    [types.FETCH_COMPLETED_QUESTIONS]: (state) => ({
      ...state,
      loadingStatus: loadingState.LOADING,
    }),
    [types.FETCH_COMPLETED_QUESTIONS_SUCCESS]: (state, action) => {
      const { questions, count, hasUnread, currentPage } = action.payload;

      return {
        ...state,
        loadingStatus: loadingState.READY,
        questions,
        count,
        hasUnread,
        currentPage,
      };
    },
    [types.FETCH_COMPLETED_QUESTIONS_FAILED]: (state, action) => ({
      ...state,
      loadingStatus: loadingState.ERROR,
      errorMessage: action.payload.errorMessage,
    }),
    [types.UPDATE_COMPLETED_QUESTIONS_COUNT]: (state, action) => ({
      ...state,
      count: action.payload.count,
    }),
    [types.UPDATE_AASMSTATE_AFTER_RATE_SUCCESS]: (state, action) => {
      let { questions } = state;
      const { question } = action.payload.updatedQuestion.rate;

      questions.map((q, pos, arr) => {
        if (q.id === question.id) arr.splice(arr.indexOf(q), 1);
      });

      questions = questions.concat([question]);

      return {
        ...state,
        questions,
      };
    },
    [types.CLEAN_COMPLETED_QUESTIONS]: (state) => ({
      ...state,
      questions: [],
      currentPage: 0,
      count: 0,
      hasUnread: false,
      errorMessage: '',
    }),
  },
  INIT_STATE
);

export default reducer;
export const getCompletedQuestions = (state) =>
  state.questions.completedQuestions;
export const getCompletedQuestionsCount = createSelector(
  getCompletedQuestions,
  (completedQuestions) => completedQuestions.count
);
export const getCompletedQuestionsHasUnread = createSelector(
  getCompletedQuestions,
  (completedQuestions) => completedQuestions.hasUnread
);
export const getCompletedQuestionsList = createSelector(
  getCompletedQuestions,
  (completedQuestions) => completedQuestions.questions
);



// WEBPACK FOOTER //
// ./src/scenes/Home/services/redux/completedQuestions.js